import type { Theme } from '@mui/material';

export const styles = {
  dropTarget: (canDrop: boolean, isOver: boolean) => (theme: Theme) => {
    const result: Record<string, string> = {
      justifyContent: 'center',
      alignItems: 'center',
      height: '6.25rem',
      color: theme.colors.white,
    };

    if (canDrop) {
      if (isOver) {
        Object.assign(result, { backgroundColor: theme.colors.green[400] });
      } else {
        Object.assign(result, { backgroundColor: theme.colors.neutral[400] });
      }
    } else {
      Object.assign(result, { backgroundColor: theme.colors.neutral[300] });
    }

    return result;
  },
};
